import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  totalAmount: "100000",
  taxSlab: "12",
  gstType: "excluding",
 
  gstErrors: null
};

const gstSlice = createSlice({
  name: 'gstCalculator',
  initialState,
  reducers: {
    setTotalAmount: (state, action) => {
      state.totalAmount = action.payload;
    },
    setTaxSlab: (state, action) => {
      state.taxSlab = action.payload;
    },
    setGstType: (state, action) => {
      state.gstType = action.payload;
    },
    setGstErrors: (state, action) => {
      state.gstErrors = action.payload;
    },
    setGstValue: (state, action) => {
      state.gstValue = action.payload;
    },
    setRemoveVatFields(state) {
      state.totalAmount = "";
      state.taxSlab = "";
      state.gstType = "";
      state.calculatedGst = "";
      state.gstErrors = null;
    },
       resetGstData: (state) => {
          return initialState;
        },
  }
});

export const {
  setTotalAmount, 
  setTaxSlab, 
  setGstType, 
  setGstErrors, 
  setGstValue,
  setRemoveVatFields,resetGstData
} = gstSlice.actions;

export default gstSlice.reducer;
